exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".q2y7w0VvwQHpEuwdCjcBC{width:50%}", ""]);
// Exports
exports.locals = {
	"column": "q2y7w0VvwQHpEuwdCjcBC"
};